import { Lock, FileCheck2, ScrollText, UserCheck, ShieldCheck } from "lucide-react";

const items = [
  { icon: FileCheck2, title: "Solo provvedimenti verificati", text: "Ogni segnalazione richiede il PDF della convalida di sfratto e viene esaminata prima di comparire nelle ricerche." },
  { icon: UserCheck, title: "Finalità dichiarata", text: "Ogni ricerca richiede la dichiarazione di finalità legata alla valutazione di una candidatura di locazione." },
  { icon: ScrollText, title: "Registro delle ricerche", text: "Ogni consultazione viene registrata con utente, data e risultato, a tutela degli interessati." },
  { icon: Lock, title: "Passaporto solo con consenso", text: "Lo storico dei pagamenti è condivisibile solo con consenso dell'inquilino e revocabile in ogni momento." },
];

export const Gdpr = () => (
  <section id="garanzie" className="relative overflow-hidden bg-[#172554] py-16 text-white grain md:py-24">
    <div className="relative mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[1fr_1.2fr] lg:px-8">
      <div>
        <span className="eyebrow-label !text-[#93c5fd]"><ShieldCheck className="h-4 w-4" />Conformità GDPR</span>
        <h2 className="mt-4 text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">Progettata secondo il Regolamento UE 2016/679.</h2>
        <p className="mt-5 max-w-md text-slate-300">I dati giudiziari meritano il massimo rigore. Per questo AffittoSicuro limita, verifica e traccia ogni trattamento.</p>
        <div className="mt-10 hidden overflow-hidden rounded-2xl lg:block">
          <img src="/images/contract.jpg" alt="Firma di un contratto di locazione" className="h-64 w-full object-cover opacity-90" />
        </div>
      </div>
      <div className="grid gap-px overflow-hidden rounded-2xl bg-white/10 sm:grid-cols-2">
        {items.map(({ icon: Icon, title, text }) => (
          <div key={title} className="bg-[#172554] p-7 hover:bg-[#1e3a8a]" style={{ transition: "background-color 200ms" }}>
            <Icon className="h-6 w-6 text-[#93c5fd]" />
            <h3 className="mt-4 text-lg font-semibold">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-300">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
